/**
 * 環境毎に異なる設定値を取得する
 *
 * @returns {Env} env
 */
export var getEnv = function () {
    return window.env;
};
